import styled, { css } from 'styled-components';
import { rem } from '~/src/helpers/rem-converter.helper';
import { RegNumberInput } from '~/src/components/common-components/reg-number-input/reg-number-input';
import { mediaQuery } from '~/src/styles/mixins';
import { MAX_1279 } from '~/src/styles/tokens/break-points';

const CommonFieldsStyles = css`
    width: calc(50% - ${rem(16)});

    ${mediaQuery({ maxWidth: MAX_1279 },
        css`
            width: 100%;
        `,
    )};
`;

export const OrganizationInfoSubDataInputsWrapper = styled.div<{ disabledRegInputs?: boolean; }>`
    display: ${p => p.disabledRegInputs ? 'flex' : 'none'};
    width: 100%;
    flex-direction: column;
    gap: ${rem(24)};
`;

export const RegContainer = styled.div`
    width: 100%;
    gap: ${rem(32)};
    
    ${mediaQuery({ maxWidth: MAX_1279 },
        css`
            gap: ${rem(24)};
        `,
    )};
`;

export const RegNumberInputWrap = styled(RegNumberInput)`
    ${CommonFieldsStyles};
`;

